const VISIBLE_COUNT_BREAKPOINTS = [
  { minWidth: 1920, count: 11 },
  { minWidth: 1836, count: 10 },
  { minWidth: 1536, count: 8 },
  { minWidth: 1280, count: 7 },
  { minWidth: 1024, count: 6 },
  { minWidth: 768, count: 4 },
  { minWidth: 0, count: 3 },
]

export const getVisibleCount = (width, size = 'lg') => {
  const breakpoint = VISIBLE_COUNT_BREAKPOINTS.find((entry) => width >= entry.minWidth)
  const baseCount = breakpoint?.count ?? 4
  return size === 'sm' ? baseCount * 2 : baseCount
}
